import * as R from 'ramda';

const add = store => async (state, { title, id }) => {
    const userClientId = state.user.selectedUserClientId;

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'reports', 'byId', id],
            {
                title,
                isDownloading: true,
                isDownloaded: false,
                isShowing: true,
            },
            store.getState(),
        ),
        true,
    );
};

export default add;
